import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Field from 'components/AddOrEditFormPage/CustomForm/Field'
// import FieldCheckbox from 'components/AddOrEditFormPage/CustomForm/FieldCheckbox'
import { handleSectionValueChange } from 'actions/customForm/addOrEdit'
import NumberFormat from 'components/theme/NumberFormat'

const MaxCharacters = connect(null, (dispatch) =>
	bindActionCreators({ handleSectionValueChange }, dispatch),
)(({ handleSectionValueChange, itemID }) => {
	return (
		<div style={{ marginTop: 10 }}>
			<Field
				handleChange={({ property, value, type, id }) =>
					handleSectionValueChange({
						property,
						value: value || undefined,
						type,
						id,
					})
				}
				label="Max characters"
				property="max_characters"
				statePath={(state) =>
					state.customForm.addOrEdit.sectionsByID[itemID].field.max_characters
				}
				placeholder="Enter a maximum amount of allowed characters"
				type="field"
				sectionID={itemID}
				// defaultValue={0}
				inputComponent={NumberFormat}
			/>
		</div>
	)

	// return (
	// 	<div style={{ position: 'relative', marginTop: 10 }}>
	// 		<div style={{ position: 'absolute', left: 0 }}>
	// 			<FieldCheckbox
	// 				label=""
	// 				property="max_characters"
	// 				statePath={(state) =>
	// 					Boolean(
	// 						state.customForm.addOrEdit.sectionsByID[itemID].field
	// 							.max_characters,
	// 					)
	// 				}
	// 				type="field"
	// 				fieldType="number"
	// 				fieldCheckbox
	// 				sectionID={itemID}
	// 			/>
	// 		</div>
	// 		<div style={{ width: 'calc(100% - 30px)', marginLeft: 30 }}>
	// 			<Field
	// 				handleChange={({ property, value, type, id }) =>
	// 					handleSectionValueChange({
	// 						property,
	// 						value: value || undefined,
	// 						type,
	// 						id,
	// 					})
	// 				}
	// 				label="Max characters"
	// 				property="max_characters"
	// 				statePath={(state) =>
	// 					state.customForm.addOrEdit.sectionsByID[itemID].field
	// 						.max_characters || ''
	// 				}
	// 				placeholder="Enter a maximum amount of allowed characters"
	// 				type="field"
	// 				sectionID={itemID}
	// 				// defaultValue={0}
	// 				inputComponent={NumberFormat}
	// 			/>
	// 		</div>
	// 	</div>
	// )
})

export default MaxCharacters
